define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/Wa", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, Wa_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaApplication = void 0;
    class WaApplication extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Wa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedWa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeHistory", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, WaApplication.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.Wa = [];
        }
        onRead(entity, parent) {
            this.Wa = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.RefId = b.RefId;
            a.Wa = this.mergeArray(a.Wa, b.Wa, Wa_1.Wa);
            a.SelectedWa = a.SelectedWa && a.Wa.find(x => x.Id == a.SelectedWa.Id) ? a.SelectedWa : null;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, WaApplication.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqString(validationState, "RefId", "Reference Id");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.Wa) {
                for (let x of this.Wa) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                RefId: this.RefId,
                Wa: this.Wa.map(x => x.toJson()),
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get ActiveWa() {
            return this.Wa.filter(a => a.IsActive);
        }
        amend() {
            return new Promise((resolve, reject) => {
                if (this.SelectedWa) {
                    (0, EventManager_1.notify)("Amending Water Agreement");
                    services_1.SrmsServiceManager.Instance.WaterAgreementApplication.createAmendment(this.SelectedWa.toJson()).then(res => {
                        (0, EventManager_1.notify)("Amendment Complete");
                        this.SelectedWa.merge(res.Original);
                        this.Wa.push(new Wa_1.Wa(res.Amendment, this));
                        this.SelectedWa = this.Wa.find(p => p.Id == res.Amendment.Id);
                        this.IncludeHistory = true;
                        resolve();
                    });
                }
                else {
                    reject("No selected WA");
                }
            });
        }
    }
    exports.WaApplication = WaApplication;
    Object.defineProperty(WaApplication, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WaApplication"
    });
    Object.defineProperty(WaApplication, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Water Agreement Application"
    });
    Object.defineProperty(WaApplication, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "RefId"]
    });
    Object.defineProperty(WaApplication, "RefIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 50
    });
    Object.defineProperty(WaApplication, "RefIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApplication.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApplication.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApplication.prototype, "Wa", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApplication.prototype, "SelectedWa", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApplication.prototype, "WaError", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApplication.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApplication.prototype, "IncludeHistory", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], WaApplication.prototype, "ActiveWa", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApplication.prototype, "amend", null);
});
